import '@swc/helpers';
import { format } from 'date-fns';
import { DataLayer } from '@grandvisionhq/analytics';
import '@grandvisionhq/auth';

const clearEvents = ()=>{
    return DataLayer.pushEvent({
        event: '',
        events: null
    });
};
const makeOrderEvent = (block, interaction, orderId, orderDate, paymentStatus, shippingStatus)=>{
    return {
        event: 'myAccount',
        events: {
            category: 'my orders',
            action: {
                block,
                interaction,
                orderId,
                orderDate: `${format(orderDate, `ddMMyyyy`)}`,
                paymentStatus: paymentStatus || 'n/a',
                shippingStatus: shippingStatus || 'n/a'
            }
        }
    };
};
const makeOrderDetailsClickEvent = (eventType, orderCode, paymentStatus)=>{
    return {
        event_type: eventType,
        event: 'order_detail_click',
        order: {
            order_code: orderCode,
            payment_status: paymentStatus
        }
    };
};

export { clearEvents, makeOrderDetailsClickEvent, makeOrderEvent };
//# sourceMappingURL=utils.js.map
